import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [통합로그 > 저장소 구성] 저장소 설정 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getDataindexes() {
    return axios.get(`${baseUrl}/integrated-log/store/get-dataindexes.do`);
  },
  /**
   * [통합로그 > 저장소 구성] ES에서 저장소 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [조회해올 저장소의 dataindexOrigin]
   * @return {[type]}        [description]
   */
  getLogIndices(params) {
    return axios.get(`${baseUrl}/integrated-log/store/get-log-indices.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 저장소 요약 정보를 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getStoreSummary() {
    return axios.get(`${baseUrl}/integrated-log/store/get-store-summary.do`);
  },
  /**
   * [통합로그] 수집 서버 트리 데이터를 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getCollectorTree() {
    return axios.get(`${baseUrl}/log/config/get-collector-tree.do`);
  },
  /**
   * [통합로그 > 저장소 구성] 수집 서버 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getLogCollectors() {
    return axios.get(`${baseUrl}/integrated-log/store/get-log-collectors.do`);
  },
  /**
   * [통합로그 > 저장소 구성] 선택된 수집서버에 저장된 로그 파일 목록을 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [logCollectorId]
   * @return {[type]}        [description]
   */
  getFilesByCollector(params) {
    return axios.post(`${baseUrl}/integrated-log/store/get-files-by-collector.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 로그 파일을 다운로드한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportLogFile(params) {
    return axios.post(`${baseUrl}/integrated-log/store/export-log-file.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 선택한 저장소를 스냅샷으로 백업한다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  createSnapshot(params) {
    return axios.post(`${baseUrl}/integrated-log/store/create-snapshot.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 백업된 저장소 스냅샷 목록을 조회해온다.
   * @author Minyeong
   * @return {[type]} [description]
   */
  getSnapshots(params) {
    return axios.get(`${baseUrl}/integrated-log/store/get-snapshots.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 스냅샷으로 저장소를 복구한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  restoreDataindex(params) {
    return axios.post(`${baseUrl}/integrated-log/store/restore-dataindex.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 스냅샷 상태를 확인한다.
   * @author Minyeong
   * @param  {[type]} params [상태 확인할 스냅샷 이름(인덱스 이름과 동일)]
   * @return {[type]}        [description]
   */
  checkSnapshotStatus(params) {
    return axios.post(`${baseUrl}/integrated-log/store/check-snapshot-status.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 저장소 복구 상태를 확인한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkRestoreStatus(params) {
    return axios.post(`${baseUrl}/integrated-log/store/check-restore-status.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 스냅샷으로 백업된 인덱스를 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [삭제할 인덱스 이름]
   * @return {[type]}        [description]
   */
  deleteIndex(params) {
    return axios.post(`${baseUrl}/integrated-log/store/delete-index.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 인덱스 삭제 실패 시 해당 인덱스의 스냅샷을 삭제한다.
   * @author Minyeong
   * @param  {[type]} params [삭제할 스냅샷 이름]
   * @return {[type]}        [description]
   */
  deleteSnapshot(params) {
    return axios.post(`${baseUrl}/integrated-log/store/delete-snapshot.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 파일의 정합성 검사를 수행한다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  performCheckFileHash(params) {
    return axios.post(`${baseUrl}/integrated-log/store/perform-check-file-hash.do`, params);
  },
  /**
   * [통합로그 > 저장소 구성] 파일의 정합성 검사 진행 상태를 조회해온다.
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getHashCheckRunningStatus(params) {
    return axios.post(`${baseUrl}/integrated-log/store/get-hash-check-running-status.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/log/log-store.js